import AxiosApiClient from './AxiosApiClient';


//for all API calls
const auth_api = 'phpLaravel';
if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
    auth_api = localStorage.getItem('auth_api');
}

/**
 * Send user activity to backend
 * @param {Object} params
 * @param {string} params.objectEvent - event name (e.g. LOAD_ALBUM, PLAY_TRACK)
 * @param {string} [params.objectType]
 * @param {string} [params.objectTitle]
 */
export async function trackActivity({
    objectEvent,
    objectType = null,
    objectTitle = null,
}) {

    //values sent to api
    const payload = {
        ajax_flag: localStorage.getItem('ajax_flag'),
        objectEvent: objectEvent,
        objectType: objectType,
        objectTitle: objectTitle,
    }

    const sendApiObjectData = async () => {
        try {
            const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
            await getBearerToken();
            const response = await makeRequestWithHeaders('post', '/api/track_activity', payload, {});

            setApiObjectData(response, "sendApiObjectData");
        } catch (error) {
            handleApiErrorObjectData(error, "sendApiObjectData");
        }
    };

    sendApiObjectData();

}
function setApiObjectData(response, theFunction) {
    if (response && response.data) {
        if (response.data.status === 200) {//HTTP_OK
            console.log(theFunction + ': ', response.data.message);
        } else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');
        } else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
            console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');
        } else {//more errors
        }
    }
}
function handleApiErrorObjectData(error, theFunction) {
    console.log(theFunction + ' error: ', error + ' back-end api call error');
}
